
export const machineOptions = {
        'Introduction Module': true,
        Helicopters: false,
        'Airframe Structures': true,
        'Airframe Systems': true,
        'Turbine Engine': true,
        'Piston Engine': false,
        Propellers: true,
        Internal: true,
    }